
import { Component, Prop, Vue } from "vue-property-decorator";
import config, { FormConfig, FormValid } from "@/config";
import { validForm } from "@/common/utils";
import { Action } from "vuex-class";
import { md5 } from "@/toolUtil/md5";
import cookie from "js-cookie";
@Component({
  name: "Login",
})
export default class Login extends Vue {
  @Action("clearAddresStorage") private clearAddresStorage: any;
  @Action("account/getAuthernData") private getAuthern: any;
  @Action("account/getMail") private getMail: any;
  @Action("account/loginOrRegister") private loginOrRegister: any;
  @Action("account/loginPhone") private loginPhone: any;
  checkPhone = (rule: any, value: any, callback: any) => {
    const reg = /^1[345789]\d{9}$/;
    if (!reg.test(value)) {
      callback(new Error("请输入11位手机号"));
    } else {
      callback();
    }
  };
  active: any = 0;
  login_form: any = {
    account: "",
    password: "",
  };
  rules: any = {
    account: [
      {
        required: true,
        message: "请输入账号或手机号",
        trigger: "blur",
      },
    ],
    password: [
      {
        required: true,
        message: "请输入密码",
        trigger: "blur",
      },
    ],
  };
  // 验证码登录
  code_form: any = {
    mobile: "",
    code: "",
  };
  code_rule: any = {
    mobile: [
      {
        required: true,
        message: "请输入手机号",
        trigger: "blur",
      },
      { validator: this.checkPhone },
    ],
    code: [
      {
        required: true,
        message: "请输入验证码",
        trigger: "blur",
      },
    ],
  };
  isSend: boolean = false;
  sendCodeText: string = "发送验证码";
  login_radio_type: any = [];
  loginData: any = [];
  num: number = 60;
  timer: any = "";
  // 设置验证码倒计时缓存
  setTimeCookie(time = "60") {
    cookie.set(`codeTime`, time);
  }
  getTimeCookie() {
    return cookie.get(`codeTime`);
  }
  countDown() {
    if (this.num > 0) {
      this.num -= 1;
      this.setTimeCookie(String(this.num));
      this.sendCodeText = `${this.num}秒后`;
      this.timer = setTimeout(this.countDown, 1000);
      this.isSend = true;
    } else {
      this.resetCountDown();
    }
  }
  resetCountDown() {
    clearTimeout(this.timer);
    this.timer = null;
    this.num = 60;
    this.sendCodeText = "发送验证码";
    this.isSend = false;
  }
  // 发送验证码
  sendCode() {
    const reg = /^1[345789]\d{9}$/;
    const { mobile } = this.code_form;
    if (!reg.test(mobile)) {
      return this.$message.warning("请正确的填写手机号");
    }
    const options = { mobile: mobile, verificationEnums: "LOGIN" };
    this.getMail(options).then((res: any) => {
      if (res) {
        // this.requestId = res;
        this.setTimeCookie();
        // this.setId(res);
        this.countDown();
        return res;
      }
    });
  }
  // 清除表单
  clearForm() {
    this.$nextTick(() => {
      // 密码登录
      if (this.active == 0) {
        this.login_form = {
          account: "",
          password: "",
        };
        (this.$refs.login_form as any).resetFields();
        (this.$refs.login_form as any).clearValidate();
      } else {
        // 验证码登录
      }
    });
  }
  created() {
    const num = Number(this.getTimeCookie());
    if (num >= 0) {
      this.num = num;
      this.countDown();
    }
    this.getData();
    //this.clearAddresStorage();
  }
  getData() {
    const { login_radio_type } = FormConfig;
    this.login_radio_type = login_radio_type;
  }
  toRegist() {
    const params = this.$route.params;
    this.$router.push({ path: "/regist", params });
  }
  async login() {
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    setTimeout(() => {
      loading && loading.close();
    }, 30000);
    // 密码登录
    if (this.active == 0) {
      this.passwordLogin(loading);
    } else if (this.active == 1) {
      this.codeLogin(loading);
    }
  }
  // 验证码登录
  async codeLogin(loading: any) {
    const ref: any = this.$refs.code_form;
    const is_valid = await validForm(ref);
    if (!is_valid) {
      loading && loading.close();
      return this.$message.warning("请填写正确的账号和验证码");
    }
    const { mobile, code } = this.code_form;
    const options = {
      code: code,
      mobile,
    };
    this.loginPhone(options)
      .then((res: any) => {
        loading && loading.close();
        if (res.code == 200) {
          this.$message.success("登录成功");
          // this.$router.push({ name: 'PcmHome' })
        } else {
          this.$message.error(res.message);
        }
      })
      .catch(() => {
        loading && loading.close();
      });
  }
  // 密码登录
  async passwordLogin(loading: any) {
    const ref: any = this.$refs.login_form;
    const is_valid = await validForm(ref);
    if (!is_valid) {
      loading && loading.close();
      return this.$message.warning("请填写正确的账号密码");
    }

    const { account, password } = this.login_form;
    const options = {
      username: account,
      password: md5(password),
      // state: this.login_radio_type[this.active].value,
    };
    await this.$store
      .dispatch("account/login", options)
      .then((res: any) => {
        loading && loading.close();
        if (res.code == 200) {
          console.log(res);
          cookie.set("accessToken", res.result.accessToken);
          /*const { idNature, soleSave } = res
        const beforePath = this.$route.params.beforePath
        const query: any = this.$route.params.beforeOption
        if (beforePath) {
          this.$router.push({ path: beforePath, query })
        } else {
          this.$router.push({ path: `/${idNature}/home` })
        }*/

          this.$message.success("登录成功");
        } else {
          console.log(res);
          this.$message.error(res.message);
        }
        return false;
      })
      .catch(() => {
        loading && loading.close();
      });
  }
}
